<!--  -->
<template>
  <div class="main">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span>道具管理</span>
      <i class="el-icon-arrow-right"></i>
      <span>{{ routeName }}</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ list[isIndex] }}</span>
    </p>
    <div class="box-prop">
      <div class="flex-box2">
        <div
          v-for="(item, index) in list"
          :key="index"
          :class="index == isIndex ? 'text-item active' : 'text-item'"
          @click="listChange(item, index)"
        >
          {{ item }}
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding: 20px 0;
          margin-top: 20px;
        "
      >
        <div class="left">
          <div
            v-for="item in propsList"
            :key="item.id"
            class="prop-card flex-box"
            :class="{
              'card-active': selectedProp && selectedProp.id === item.id,
            }"
            :style="
              item.background
                ? { backgroundImage: `url(${item.background})` }
                : getCardStyle(item.id)
            "
            @click.stop="isIndex == 0 ? selectCard(item) : viewPropDetail(item)"
          >
            <div class="prop-card-info">
              <div class="prop-card-name">
                {{ item.name }}
              </div>
              <div class="prop-card-desc">
                {{ item.description || "" }}
              </div>
            </div>
            <div class="prop-card-action">
              <el-button
                type="primary"
                style="width: 100px"
                @click.stop="
                  isIndex == 0 ? selectCard(item) : viewPropDetail(item)
                "
                >{{ isIndex == 0 ? "购买" : "查看" }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="right" v-show="isIndex == 0 && selectedProp">
          <div class="title">{{ selectedProp && selectedProp.name }}购买</div>
          <div class="title2 flex-box">
            <span style="color: #666"> 套餐选择：</span>
            <span>
              （{{
                calcResult && calcResult.endTime
                  ? calcResult.endTime + "到期"
                  : "选择套餐后显示到期时间"
              }}）</span
            >
          </div>
          <div class="flex-box2">
            <div
              v-for="(item, index) in list2"
              :key="item.id || index"
              :class="
                isIndex2 == index
                  ? 'pay-option-box pay-option-box-active'
                  : 'pay-option-box'
              "
              @click="list2Change(item, index)"
            >
              {{ getPriceSpecName(item) }}
            </div>
          </div>
          <div class="flex-box">
            <div class="title2">
              <span>数量：</span>
              <el-input-number
                size="small"
                v-model="num"
                :min="1"
                :max="10"
                label="描述文字"
              >
              </el-input-number>
            </div>
            <div class="title2">
              价格：<span style="font-size: 16px; color: #fe574a"
                >{{
                  calcResult && calcResult.amount != null
                    ? calcResult.amount
                    : displayPrice
                }}</span
              >元
            </div>
          </div>
          <div style="display: flex; justify-content: center; margin-top: 5px">
            <el-button
              type="primary"
              style="width: 100px"
              @click="openPayDialog"
              >立即购买</el-button
            >
          </div>
        </div>
        <div
          class="right2"
          v-show="isIndex == 1 && selectedProp"
          @scroll.passive="handleUsageScroll"
        >
          <div class="title">
            {{ selectedProp && selectedProp.name }}
          </div>
          <div
            class="title2"
            v-if="detailPropCount != null || detailExpireTime"
          >
            剩余次数：
          </div>
          <div
            class="title2"
            v-if="detailPropCount != null || detailExpireTime"
          >
            {{ (selectedProp && selectedProp.name) || "" }}
            <span style="color: green; font-size: 16px"
              >（{{ detailPropCount ?? 0 }}）</span
            >：最早到期时间 {{ detailExpireTime || "--" }}
          </div>
          <div
            v-for="(item, index) in useRecordList"
            :key="index"
            class="box-item"
          >
            <div>
              <span>{{
                item.content || (selectedProp && selectedProp.name) || ""
              }}</span>
            </div>
            <div>
              <span>{{ item.createTimeStr || "--" }}</span>
            </div>
          </div>
          <div
            v-if="
              isIndex == 1 &&
              selectedProp &&
              (!useRecordList || !useRecordList.length)
            "
            class="title2"
            style="text-align: center; color: #999"
          >
            暂无使用记录
          </div>
        </div>
        <dialogModel
          title="付款"
          :visible.sync="dialogVisible"
          :footer="false"
          @handleClose="dialogVisible = false"
        >
          <div style="padding: 50px 25%">
            <div class="flex-box">
              <div style="font-size: 16px; color: #000">
                {{ selectedProp ? selectedProp.name : "" }}
              </div>
              <div style="font-size: 16px; color: #fe574a">
                {{ calcResult ? calcResult.originalPrice : price }}元
              </div>
            </div>
            <div class="flex-box" style="margin: 20px 0">
              <div style="font-size: 12px; color: #999">
                {{ list2[isIndex2] && getPriceSpecName(list2[isIndex2]) }}
              </div>
              <div style="font-size: 16px; color: #fe574a">×{{ num }}</div>
            </div>
            <div class="flex-box" style="margin: 20px 0">
              <div
                class="flex-box"
                style="cursor: default; align-items: center"
              >
                <span style="margin-right: 10px">是否使用侦迹币</span>
                <el-switch
                  v-model="useCoin"
                  :disabled="traceCoinFrozen || Number(coinBalance || 0) <= 0"
                  @change="handleUseCoinChange"
                />
                <span style="font-size: 12px; color: #999; margin-left: 8px"
                  >（余额{{ coinBalance }}）</span
                >
                <span
                  v-if="traceCoinFrozen"
                  style="font-size: 12px; color: #fe574a"
                >
                  （侦迹币已被冻结）
                </span>
              </div>
              <div v-if="calcResult && Number(calcResult.coinDeduct) > 0">
                减<span style="font-size: 14px; color: #fe574a"
                  >{{ calcResult.coinDeduct }}</span
                >元
              </div>
            </div>
            <div class="flex-box">
              <div>应付款</div>
              <div style="font-size: 16px; color: #fe574a">
                {{ calcResult ? calcResult.finalPrice : displayPrice }}元
              </div>
            </div>
            <div style="margin: 20px 0">
              <div
                v-if="needThirdPay"
                style="font-size: 14px; color: #333; margin-bottom: 10px"
              >
                支付方式：
                <span v-if="useCoin" style="font-size: 12px; color: #999">
                  （侦迹币不足，剩余需支付{{
                    calcResult ? calcResult.finalPrice : displayPrice
                  }}）元
                </span>
              </div>
              <div v-if="needThirdPay" class="flex-box">
                <div
                  v-for="item in payMethodList"
                  :key="item.id"
                  :class="
                    payMethod === item.id
                      ? 'pay-option-box pay-option-box-active'
                      : 'pay-option-box'
                  "
                  style="margin-right: 10px; margin-bottom: 8px"
                  @click="payMethod = item.id"
                >
                  {{ item.name }}
                </div>
              </div>
              <div
                v-else-if="useCoin && Number(coinBalance || 0) > 0"
                style="font-size: 12px; color: #999; line-height: 20px"
              >
                本次将使用侦迹币完成支付。
              </div>
              <div
                v-else
                style="font-size: 12px; color: #999; line-height: 20px"
              >
                本次无需支付。
              </div>
            </div>
            <div style="text-align: center; margin-top: 10px; font-size: 12px;">
              付费即表示同意 <span style="color: #409eff ; cursor: pointer;" @click="handelAgreement">《侦迹云增值服务协议》</span>
            </div>
          </div>
          <template slot="footer">
            <div class="dialog-model-footer-btns">
              <el-button
                class="dialog-model-btn dialog-model-btn-cancel"
                @click="dialogVisible = false"
                >取 消</el-button
              >
              <el-button
                class="dialog-model-btn dialog-model-btn-confirm"
                :loading="payLoading"
                @click="confirmPay"
                >确认支付</el-button
              >
            </div>
          </template>
        </dialogModel>
        <!-- 人才信用卡、商机信息卡走 /info/pay，轮询用 infoTradeQuery，其他走 /global/proxy/tradeQuery -->
        <CommonPayment
          :VisiblePayment="VisiblePayment"
          :alipayForm="alipayForm"
          :totalAmount="totalAmount"
          :payMethod="payMethod"
          :orderId="orderId"
          :businessType="businessType"
          :queryType="isInfoTradePayment ? 'info' : 'proxy'"
          @handlePayment="handlePaymentClose"
          @handleSuccess="handlePaySuccess"
        />
        <VerificationPwd
          :VisiblePwd="VisiblePwd"
          @handleClosePwd="VisiblePwd = false"
          @handleUnderstandPwd="handleUnderstandPwd"
        />
      </div>
    </div>
  </div>
</template>

<script>
import * as PropAPI from "@/assets/api/firm/firmProp.js";
import { selectCompanyWalletList } from "@/assets/api/firm/firmCenter.js";
import { queryCompanyPaySetting } from "@/assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../firmCenter/ProxyService/Enterprise/Bookkeeping/components/IndexCom/VerificationPwd.vue";
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD, PAYMENT_METHODS } from "@/utils/paymentMethods";

export default {
  components: { CommonPayment, VerificationPwd },
  data() {
    return {
      dialogVisible: false,
      routeName: "",
      list: ["道具", "已购道具"],
      isIndex: 0,
      list2: [], // 道具价格规格列表 SysPropsPrice[]：id, propId, count, price, time, timeType, onoff
      isIndex2: 0,
      selectedProp: null, // 当前选中的道具 SysProps { id, name, description, background, onoff }
      num: 1,
      // 接口数据
      price: "0",
      calcResult: null,
      /**
       * 是否使用侦迹币抵扣（不再作为“支付方式”选项）
       * - 每次打开付款弹框默认 false
       * - 余额为 0 时 UI 禁用开关
       * - 抵扣后应付为 0 时，无需选择支付宝/微信
       */
      useCoin: false,
      /**
       * 企业侦迹币余额
       * 来源：企业钱包接口 selectCompanyWalletList 或 价格计算接口返回的 companyTraceCoin
       */
      coinBalance: 0,
      /**
       * 企业侦迹币账号状态（accountStatus：0冻结 1开启）
       */
      traceCoinAccountStatus: "",
      /**
       * 冻结原因（冻结状态展示）
       */
      traceCoinFreezeReason: "",
      loading: false,
      payLoading: false,
      propsList: [], // 招聘道具列表 API data 数组
      myPropsList: [],
      useRecordList: [],
      paging: { currentPage: 1, pageSize: 10, total: 0 },
      // 使用记录分页（getPropDetailAndUsageLog.usageLog）
      usagePaging: { pageNo: 1, pageSize: 10, total: 0 },
      usageLoading: false,
      // 已购道具详情：getPropDetailAndUsageLog 返回
      detailPropCount: null,
      detailExpireTime: "",
      // 支付：businessType、payMethod、businessInfo
      payMethod: DEFAULT_PAYMENT_METHOD,
      // 支付方式（去掉侦迹币支付，侦迹币改为抵扣开关）
      payMethodList: PAYMENT_OPTIONS,
      VisiblePayment: false,
      alipayForm: "",
      totalAmount: "",
      orderId: "",
      businessType: "",
      VisiblePwd: false,
      isViewingDetail: false, // 标记是否正在查看详情，避免 watch 中重复调用接口
      /** 是否开通企业支付密码（queryCompanyPaySetting） */
      PaymentPassword: false,
    };
  },
  created() {
    this.routeName = this.$route.name || "招聘道具";
  },
  mounted() {
    this.loadPropsList();
    this.refreshCompanyPaySetting();
  },
  computed: {
    /** 人才信用卡(id=2)、商机信息卡(id=3) 走 /info/tradeQuery */
    isInfoTradePayment() {
      const id = this.selectedProp && this.selectedProp.id;
      return id === 2 || id === "2" || id === 3 || id === "3";
    },
    /**
     * 是否冻结中（冻结时不允许侦迹币抵扣/支付）
     */
    traceCoinFrozen() {
      return String(this.traceCoinAccountStatus) === "0";
    },
    /**
     * 是否仍需第三方支付（支付宝/微信）
     * - true：必须选择 payMethod（ALIPAY / WECHAT_PAY）
     * - false：若勾选侦迹币，则自动用 TRACE_COIN_PAY_* 走“侦迹币直付”（不弹二维码）
     */
    needThirdPay() {
      const finalPrice = this.calcResult
        ? this.$tool.num.toNumber(this.calcResult.finalPrice)
        : this.displayPrice;
      return finalPrice > 0;
    },
    displayPrice() {
      return this.$tool.num.mul(this.price || 0, this.num || 0);
    },
  },
  watch: {
    selectedProp: {
      handler(val) {
        if (!val) return;
        // 切换已购道具时，清空详情展示，等点击“查看”后再用接口返回填充
        if (this.isIndex === 1) {
          this.detailPropCount = null;
          this.detailExpireTime = "";
          this.useRecordList = [];
          this.usagePaging = { pageNo: 1, pageSize: 10, total: 0 };
        }
        // 切换道具：重置支付方式与侦迹币抵扣
        this.payMethod = "WECHAT_PAY";
        this.useCoin = false;

        if (this.isIndex === 0) {
          this.fetchPrice();
        } else if (!this.isViewingDetail) {
          // 如果不是正在查看详情，才调用 loadMyPropsByCard
          this.loadMyPropsByCard();
        }
      },
    },
    isIndex2() {
      if (this.list2 && this.list2[this.isIndex2] != null) {
        this.price = String(this.list2[this.isIndex2].price ?? "0");
      }
      this.calcBuyPrice();
    },
    num() {
      this.calcBuyPrice();
    },
    coinBalance(val) {
      // 余额为 0 时强制关闭开关，避免出现“开着但不可用”的状态
      if ((Number(val || 0) <= 0 || this.traceCoinFrozen) && this.useCoin) {
        this.useCoin = false;
      }
      this.updatePaySummary();
    },
  },
  methods: {
    // 点击协议查看协议详情
    handelAgreement() {
      const route = this.$router.resolve({
        path: "/AboutUs/Express",
        query: { name: "侦迹云增值服务协议" },
      });
      window.open(route.href, '_blank');
    },
    /**
     * 根据道具 ID 映射到后端约定的“侦迹币支付 payMethod”
     * 仅在“抵扣后应付为 0 且勾选侦迹币”时自动使用
     */
    getTraceCoinPayMethodByPropId(propId) {
      const id = propId != null ? String(propId) : "";
      if (id === "1") return PAYMENT_METHODS.TRACE_COIN_ELITE_CARD;
      if (id === "2") return PAYMENT_METHODS.TRACE_COIN_CREDIT_CARD;
      return PAYMENT_METHODS.TRACE_COIN_BUSINESS_INFO_CARD;
    },
    /**
     * 根据 useCoin + coinBalance 回填 calcResult：
     * - originalPrice：原价
     * - coinDeduct：抵扣金额
     * - finalPrice：抵扣后应付
     */
    updatePaySummary() {
      if (!this.calcResult) return;
      const num = this.$tool.num;
      const original = num.toNumber(
        this.calcResult.originalPrice ?? this.calcResult.amount ?? 0
      );
      const balance = num.toNumber(this.coinBalance);
      const use = Boolean(this.useCoin) && !this.traceCoinFrozen && balance > 0;
      const coinDeduct = use ? num.min(original, balance) : 0;
      const finalPrice = num.max(0, num.sub(original, coinDeduct));
      this.$set(this, "calcResult", {
        ...this.calcResult,
        amount: original,
        originalPrice: original,
        useCoin: use,
        coinDeduct,
        finalPrice,
      });
    },
    /**
     * 侦迹币开关变化：打开时刷新余额，余额不足则自动关闭
     */
    async handleUseCoinChange(val) {
      if (val) {
        await this.loadTraceCoinBalance();
        if (this.traceCoinFrozen) {
          this.useCoin = false;
          this.$tool.PromptBox(
            "error",
            `侦迹币已冻结，无法使用：${
              this.traceCoinFreezeReason || "未知原因"
            }`
          );
          this.updatePaySummary();
          return;
        }
        if (Number(this.coinBalance || 0) <= 0) {
          this.useCoin = false;
        }
      }
      this.updatePaySummary();
    },
    listChange(item, index) {
      this.isIndex = index;
      this.selectedProp = null;
      if (index === 1) this.loadMyProps();
    },
    selectCard(item) {
      this.selectedProp = item;
    },
    // 无 background 时用本地图（id 1 精英卡，2 人才信用卡，其余默认第一张）
    getCardStyle(id) {
      const isElite = id === 1 || id === "1";
      const url = isElite
        ? require("@/assets/imgs/jingyingka@3x.svg")
        : require("@/assets/imgs/rencaixinyongka@3x.svg");
      return { backgroundImage: `url(${url})` };
    },
    loadMyPropsByCard() {
      this.loadPropsList();
    },
    // 使用记录滚动到底部，加载下一页
    handleUsageScroll(e) {
      const el = e.target;
      if (!el) return;
      // 距离底部小于 20px 时加载更多
      const distance = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (distance <= 20) {
        this.loadMoreUsageLog();
      }
    },
    async loadMoreUsageLog() {
      if (this.usageLoading || !this.selectedProp || !this.usagePaging.total)
        return;
      // 已经全部加载完
      if (this.useRecordList.length >= this.usagePaging.total) return;
      const nextPage = this.usagePaging.pageNo + 1;
      this.usageLoading = true;
      const res = await PropAPI.getPropDetailAndUsageLog(
        {
          data: this.selectedProp.id,
        },
        nextPage,
        this.usagePaging.pageSize
      );
      this.usageLoading = false;
      if (res && res.code === 0 && res.data) {
        const usageLog = (res.data && res.data.usageLog) || {};
        const rows = usageLog.rows || usageLog.list || [];
        if (Array.isArray(rows) && rows.length) {
          this.usagePaging.pageNo = nextPage;
          this.usagePaging.total =
            usageLog.totalCount || usageLog.total || this.usagePaging.total;
          this.useRecordList = this.useRecordList.concat(rows);
        }
      }
    },
    // 查看已购道具详情和使用记录
    async viewPropDetail(item) {
      if (!item || !item.id) return;
      // 设置标志位，避免 watch 中重复调用 loadMyPropsByCard
      this.isViewingDetail = true;
      // 选中道具，触发右侧面板显示（会触发 watch，但因为 isViewingDetail=true，不会调用 loadMyPropsByCard）
      this.selectCard(item);
      // 首次查看，重置使用记录分页
      this.usagePaging = { pageNo: 1, pageSize: 10, total: 0 };
      this.loading = true;
      const res = await PropAPI.getPropDetailAndUsageLog(
        {
          data: item.id,
        },
        this.usagePaging.pageNo,
        this.usagePaging.pageSize
      );
      this.loading = false;
      // 重置标志位
      this.isViewingDetail = false;
      if (res && res.code === 0 && res.data) {
        const data = res.data;
        // 直接使用 getPropDetailAndUsageLog 返回的字段展示
        this.detailPropCount =
          data.propCount != null ? data.propCount : this.detailPropCount;
        this.detailExpireTime = data.expireTime || this.detailExpireTime;
        // 使用记录列表：usageLog.rows
        const usageLog = data.usageLog || {};
        const rows = usageLog.rows || usageLog.list || [];
        this.useRecordList = Array.isArray(rows) ? rows : [];
        this.usagePaging.total = usageLog.totalCount || usageLog.total || 0;
      } else {
        this.$message.error(res?.msg || res?.message || "获取详情失败");
      }
    },
    list2Change(item, index) {
      this.isIndex2 = index;
    },
    // SysPropsPrice 展示名：timeType 年0月1，如 50次/月、800次/年
    getPriceSpecName(item) {
      if (!item) return "";
      if (item.name) return item.name;
      const count = item.count ?? 0;
      const timeType = item.timeType;
      const time = item.time;
      if (timeType === 0) return count + "次/年";
      if (time === 1) return count + "次/月";
      return count + "次/" + (time || "") + "月";
    },

    // 招聘道具列表 API（与已购道具同一接口）：data 为 SysProps[]，同响应里可有 myProps、useRecordList
    async loadPropsList() {
      this.loading = true;
      const res = await PropAPI.sysPropsList(
        {},
        this.paging.currentPage,
        this.paging.pageSize
      );
      this.loading = false;
      if (res && res.data != null) {
        const data = res.data;
        this.propsList = Array.isArray(data) ? data : data.list || [];
        const myList = data.myProps || data.myList || [];
        this.myPropsList = Array.isArray(myList) ? myList : [];
        this.useRecordList = data.useRecordList || data.recordList || [];
      }
    },

    // 已购道具与道具列表同一接口，只做刷新
    loadMyProps() {
      this.loadPropsList();
    },

    // 获取相关道具价格：返回 data 为 SysPropsPrice[]（id, propId, count, price, time, timeType, onoff）
    async fetchPrice() {
      if (!this.selectedProp || this.isIndex !== 0) return;
      const res = await PropAPI.getSysPropPrice({ data: this.selectedProp.id });
      const arr =
        res && res.data != null && Array.isArray(res.data) ? res.data : [];
      this.list2 = arr;
      this.isIndex2 = 0;
      this.price = arr[0] != null ? String(arr[0].price) : "0";
      if (arr.length) await this.calcBuyPrice();
    },

    // 道具购买价格计算：入参 propId、priceId、buyNum；返回 amount、companyTraceCoin、startTime、endTime、propCount
    async calcBuyPrice() {
      if (!this.selectedProp || this.isIndex !== 0) return;
      const spec = this.list2[this.isIndex2];
      if (!spec) return;
      const res = await PropAPI.calculateBuyPropPrice({
        data: {
          propId: this.selectedProp.id,
          priceId: spec.id,
          buyNum: this.num,
        },
      });
      let d = null;
      if (res && res.data) {
        d = res.data.data != null ? res.data.data : res.data;
      }
      if (d && (d.amount !== undefined || d.endTime != null)) {
        this.$set(this, "calcResult", {
          amount: d.amount,
          originalPrice: d.amount,
          coinDeduct: 0,
          finalPrice: d.amount,
          useCoin: this.useCoin,
          startTime: d.startTime,
          endTime: d.endTime,
          propCount: d.propCount,
        });
        if (d.companyTraceCoin != null) this.coinBalance = d.companyTraceCoin;
        this.updatePaySummary();
      } else {
        this.$set(this, "calcResult", null);
      }
    },

    // 查询企业是否开通支付密码
    refreshCompanyPaySetting() {
      return queryCompanyPaySetting().then((res) => {
        if (res && res.code === 0) {
          this.PaymentPassword = res.data;
          try {
            localStorage.setItem("PaymentPwd", res.data);
          } catch (e) {}
        }
        return res;
      });
    },
    // 打开付款弹窗：先确保有套餐数据再计算价格
    async openPayDialog() {
      if (!this.$checkAction()) return;
      // 每次打开付款弹框，默认关闭“使用侦迹币”
      this.useCoin = false;
      // 打开时先清空冻结/余额状态，避免上一笔数据导致开关短暂可用
      this.coinBalance = 0;
      this.traceCoinAccountStatus = "";
      this.traceCoinFreezeReason = "";
      if (!this.list2 || !this.list2.length) {
        await this.fetchPrice();
      }
      // 打开弹框前刷新余额与价格，保证展示数据准确
      await this.loadTraceCoinBalance();
      await this.calcBuyPrice();
      this.dialogVisible = true;
      this.refreshCompanyPaySetting();
    },

    // 确认支付：先拉取是否开通支付密码，再决定是否弹出验证
    async confirmPay() {
      if (!this.selectedProp) return;
      const spec = this.list2[this.isIndex2];
      if (!spec) {
        this.$message.warning("请选择套餐");
        return;
      }
      // 抵扣后仍需支付时，必须选择支付宝/微信
      if (
        this.needThirdPay &&
        this.payMethod !== "ALIPAY" &&
        this.payMethod !== "WECHAT_PAY"
      ) {
        this.$message.warning("请选择支付方式");
        return;
      }
      await this.refreshCompanyPaySetting();
      if (this.PaymentPassword === false) {
        this.handleUnderstandPwd();
      } else {
        this.VisiblePwd = true;
      }
    },
    // 查询侦迹币余额
    async loadTraceCoinBalance() {
      const res = await selectCompanyWalletList(
        {
          data: {
            companyId: this.$store.getters.getCompany.id,
          },
        },
        1,
        10
      );
      if (res && res.code === 0 && res.data) {
        if (res.data.traceCoin != null) this.coinBalance = res.data.traceCoin;
        this.traceCoinAccountStatus = res.data.accountStatus ?? "";
        this.traceCoinFreezeReason = res.data.reason ?? "";
        if (String(this.traceCoinAccountStatus) === "0") {
          this.useCoin = false;
          this.updatePaySummary();
        }
      }
    },
    // 支付密码确认后调 pay（无密码时 pwd 为空不传 password）
    async handleUnderstandPwd(pwd) {
      const spec = this.list2[this.isIndex2];
      if (!spec) return;
      this.payLoading = true;
      const id = this.selectedProp.id;
      // 不同道具的服务类型：
      // 精英卡：ELITE_CARD_BUY
      // 人才信用卡：CREDIT_CARD_BUY
      // 商机信息卡：BUSINESS_INFO_CARD_BUY
      let businessType = "ELITE_CARD_BUY";
      if (id === 1 || id === "1") {
        businessType = "ELITE_CARD_BUY";
      } else if (id === 2 || id === "2") {
        businessType = "CREDIT_CARD_BUY";
      } else {
        businessType = "BUSINESS_INFO_CARD_BUY";
      }
      const useTraceCoin =
        this.useCoin &&
        !this.traceCoinFrozen &&
        Number(this.coinBalance || 0) > 0;
      const needThirdPay = this.needThirdPay;
      const effectivePayMethod = needThirdPay
        ? this.payMethod
        : useTraceCoin
        ? PAYMENT_METHODS.TRACE_COIN  // 统一使用 TRACE_COIN_PAY
        : this.payMethod;
      const payData = {
        data: {
          businessType,
          payMethod: effectivePayMethod,
          businessInfo: {
            priceId: spec.id,
            count: this.num,
            // 用侦迹币付款或勾选侦迹币时，useTraceCoin 为 1
            useTraceCoin: useTraceCoin ? 1 : 0,
          },
        },
      };
      if (pwd) payData.data.password = pwd;
      const res = await PropAPI.pay(payData);
      this.payLoading = false;
      this.VisiblePwd = false;
      if (res && (res.code === 0 || res.code === 200 || res.success)) {
        this.dialogVisible = false;
        const resPayMethod =
          (res && res.data && res.data.payMethod) ||
          payData.data.payMethod ||
          "";
        const isTraceCoinPay =
          String(resPayMethod).indexOf("TRACE_COIN_PAY") === 0;
        // 侦迹币支付：不弹二维码，直接成功并刷新
        if (isTraceCoinPay) {
          // loadMyProps 内部也是调用 loadPropsList，所以只调用一次即可
          this.loadPropsList();
          this.$tool.PromptBox("success", "付款成功");
          this.loadTraceCoinBalance();
        } else {
          // 支付宝/微信：弹二维码
          this.alipayForm = res.data.payPage || "";
          this.totalAmount = res.data.totalAmount || "";
          this.orderId = res.data.orderId || "";
          this.businessType =
            res.data.businessType || payData.data.businessType;
          this.payMethod = res.data.payMethod || payData.data.payMethod;
          this.VisiblePayment = true;
        }
      } else {
      }
    },
    handlePaymentClose() {
      this.VisiblePayment = false;
    },
    handlePaySuccess() {
      this.VisiblePayment = false;
      // loadMyProps 内部也是调用 loadPropsList，所以只调用一次即可
      this.loadPropsList();
    },
  },
};
</script>
<style lang="less" scoped>
.box-prop {
  width: 100%;
  min-height: 700px;
  box-sizing: border-box;
  margin-top: 20px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(125, 125, 125, 0.5);
  border-radius: 20px;
  padding: 30px;

  .text-item {
    background-color: #eee;
    width: 110px;
    font-size: 12px;
    padding: 10px 5px;
    text-align: center;
    margin-right: 20px;
    border-radius: 5px;
    cursor: pointer;
    box-sizing: border-box;
  }

  .active {
    background-color: rgba(97, 144, 232, 0.2);
    color: #409eff ;
  }

  .left {
    margin-right: 20px;

    .prop-card {
      width: 680px;
      height: 140px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      font-size: 12px;
      padding: 0 30px;
      margin: 0 0 10px 0;
      box-sizing: border-box;
      border-radius: 20px;
      cursor: pointer;
      align-items: center;
      overflow: hidden;

      .prop-card-info {
        flex: 1;
        min-width: 0;
        max-width: 360px;
        padding-right: 16px;
        box-sizing: border-box;
      }

      .prop-card-name {
        color: #409eff ;
        font-size: 20px;
        font-weight: 600;
      }

      .prop-card-desc {
        margin-top: 20px;
        color: #666;
        line-height: 1.5;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-all;
      }

      .prop-card-action {
        flex-shrink: 0;
      }
    }

    .prop-card + .prop-card {
      margin-top: 10px;
    }

    .card-active {
      box-shadow: 0px 0px 5px 0px rgba(97, 144, 232, 1);
      box-sizing: border-box;
    }
  }

  .right {
    width: 450px;
    height: 292px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 30px 20px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      color: #409eff ;
      font-weight: 700;
    }

    .title2 {
      font-size: 12px;
      color: #666;
      margin: 25px 0;
    }
  }

  .right2 {
    width: 450px;
    max-height: 620px;
    background: #ffffff;
    box-shadow: 0px 0px 5px 0px rgba(125, 125, 125, 0.5);
    border-radius: 20px;
    padding: 30px 20px;
    box-sizing: border-box;
    overflow-y: auto;

    .title {
      font-size: 16px;
      color: #409eff ;
      font-weight: 700;
    }

    .title2 {
      font-size: 12px;
      color: #666;
      margin: 25px 0;
    }

    .box-item {
      height: 35px;
      background: #ffffff;
      border: 1px solid #dddddd;
      border-radius: 10px;
      margin-bottom: 10px;
      font-size: 12px;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
}

/* 弹窗 append-to-body 后不在 .box-prop 内，支付方式样式需提到根级 */
.pay-option-box {
  width: 90px;
  height: 35px;
  line-height: 35px;
  background: #ffffff;
  border: 1px solid #409eff ;
  border-radius: 5px;
  font-size: 12px;
  text-align: center;
  color: #409eff ;
  cursor: pointer;
  margin-right: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  flex-shrink: 0;
}

.pay-option-box-active {
  background: rgba(97, 144, 232, 0.27);
}
</style>
